import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 6a7 3 0 1 0 14 0a7 3 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M5 6v12c0 1.657 3.134 3 7 3s7 -1.343 7 -3v-12","key":"svg-1"}]]

/**
 * IconCylinder
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3lsaW5kZXIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgNmE3IDMgMCAxIDAgMTQgMGE3IDMgMCAxIDAgLTE0IDAiIC8+CiAgPHBhdGggZD0iTTUgNnYxMmMwIDEuNjU3IDMuMTM0IDMgNyAzczcgLTEuMzQzIDcgLTN2LTEyIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/cylinder
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCylinder = createReactComponent('outline', 'cylinder', 'Cylinder', __iconNode);

export default IconCylinder;